export type PaginationParams = {
  pageNumber: string;
};

export type SortingParams = {
  orderBy: string;
  order: 'asc' | 'desc';
};

export type TableHeadersConfig = {
  title: string;
  sortingKey?: string;
};

export type SearchParams = {
  search: string;
};
export type FilterParams = {
  sorting?: SortingParams;
  search?: SearchParams;
};

export type GenericQueryParams = {
  pagination: PaginationParams;
} & FilterParams;

export function getParamsFromFilters(queryParams: FilterParams) {
  let params = {};
  Object.values(queryParams).forEach((param) => {
    params = { ...params, ...param };
  });
  return params;
}


// WEBPACK FOOTER //
// ./src/utils/utils.ts